import { useEffect, useState, useCallback } from "react";
import { MaxUint256 } from "ethers";
import { useContracts } from "@/hooks/useContracts";
import { getContracts, getProvider } from "@/lib/contracts";

export function useCatclawAllowance(spender?: string) {
  const { account, connected, catclaw } = useContracts();
  const [allowance, setAllowance] = useState<bigint>(0n);
  const [isLoading, setIsLoading] = useState(false);

  const refresh = useCallback(async () => {
    if (!account || !connected || !spender) {
      setAllowance(0n);
      return;
    }
    try {
      const { catclaw: catclawRead } = getContracts(getProvider());
      const value = await catclawRead.allowance(account, spender);
      setAllowance(value as bigint);
    } catch {
      setAllowance(0n);
    }
  }, [account, connected, spender]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const approve = async () => {
    if (!account || !connected || !spender) return;
    setIsLoading(true);
    try {
      const tx = await catclaw.approve(spender, MaxUint256);
      const provider = getProvider();
      await provider.waitForTransaction(tx.hash, 1, 30000);
      await refresh();
    } finally {
      setIsLoading(false);
    }
  };

  return { allowance, isLoading, approve, refresh };
}
